import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { mediaQueries } from '@sternum/web/config/mediaQueries';
import { ct } from '@sternum/web/utils/theme';

export const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: ${ct({ Dark: Colors.DarkestMiddle, Light: Colors.DarkestMiddle })};
`;

export const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  max-width: 620px;
  width: 100%;
  padding: 20px;
`;

export const LogoBox = styled.div`
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
`;

export const TopLinesWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: max(15vw, 15vh);

  @media (${mediaQueries.lg}) {
    width: 283px;
  }
`;

export const CenterLinesWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: max(40vw, 40vh);

  @media (${mediaQueries.lg}) {
    width: 666px;
  }
`;

export const BottomLinesWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: max(15vw, 15vh);

  @media (${mediaQueries.lg}) {
    width: 292px;
  }
`;
